import { type TranslatableText } from '../../../../types/TranslatableText.type'
import { type SocialLinks } from '../../service/festival.service'

export type WebviewContact = {
  icon: string
  names: TranslatableText
  target?: string
}

export type MusicGroup = {
  _id?: string
  externalId?: string
  names: TranslatableText
  /** GuestType id */
  type?: string
  showArtist: boolean
  villageEvent: boolean
  /** Datetime */
  notVisibleUntil?: string
  label?: null | 'SPECTACLE_ENFANT' | 'ITINERANT' | 'MAGICIEN'
  weight?: number | null
  location?: string[] | null
  genres?: string[]
  tags?: Genre[]
  image?: string
  copyright?: string
  descriptions: TranslatableText
  links: { [key in SocialLinks]?: string }
  email?: string
  address?: string
  phone?: string
  contact?: string
  webview?: WebviewContact
  lineUp?: TranslatableText
  freeze: boolean
}

export type Genre = {
  _id: string
  names: TranslatableText
  nameNormalized?: string
  category?: Category
  color?: string
  externalId?: string
}

export type Category = {
  _id: string
  names: TranslatableText
  isFilterable: boolean
  index: number
  includeInForm: boolean
  freeze?: boolean
}

export type EditableCategory = Omit<Category, '_id' | 'index'> &
  Partial<Pick<Category, '_id' | 'index'>>

export type Tag = Omit<Genre, '_id' | 'category'> &
  Partial<Pick<Genre, '_id'>> & {
    category?: AnyCategory
  }

export type Marked<K, T> = K & { __marker: T }

export type TagCategory = EditableCategory & {
  _localId: string
}

export type TemporaryCategory = Marked<TagCategory, 'Temporary'>

export const isTemporaryCategory = (
  category: AnyCategory,
): category is TemporaryCategory => {
  return (category as TemporaryCategory).__marker === 'Temporary'
}

export type AnyCategory = Category | TagCategory | EditableCategory

export type UsageItem = {
  id: string
  name?: TranslatableText
}

export type GenreUsage = {
  events: UsageItem[]
  musicGroups: UsageItem[]
}

export type DeleteUnusedGenresResult = {
  deletedTagsCount: number
  deletedCategoriesCount: number
}
